import React, { useState, useEffect } from "react";
import { Card, Figure, Button, Offcanvas, Carousel } from "react-bootstrap";
import axios from "axios";
import backgroundhome from "../../picture/wallpaperflare.com_wallpaper.jpg";
import { BsChatText } from "react-icons/bs";

const Home = () => {
  const [isAdmin, setIsAdimin] = useState(undefined);
  async function checkadminreq() {
    if (
      sessionStorage.getItem("type_user") === "caat" ||
      sessionStorage.getItem("type_user") === "nbtc"
    ) {
      setIsAdimin(true);
    } else {
      setIsAdimin(false);
    }
  }
  useEffect(() => {
    checkadminreq();
    
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  
  return (
    <>
    
      {isAdmin ? (
        <Figure style={{ margin: "0", width: "100%" }}>
          <div style={{ display: "flex" }}>
            <img
              alt="sd"
              src={backgroundhome}
              style={{
                objectFit: "cover",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "100%",
                height: "93.75vh",
              }}
            />
          </div>
        </Figure>
      ) : (
        <>
          <div className="main-bg">
            <div className="center-box">
              <div style={{ margin: "auto", height: "auto" }}>
                <Button
                  style={{ float: "right" }}
                  variant="light"
                  onClick={handleShow}
                >
                  <BsChatText></BsChatText>
                </Button>
              </div>

              <Carousel className="center-carousel-main">
                <Carousel.Item className="center-text">
                  <div className="center-img" />
                  <h2 style={{ border: "bold" }}>
                    กฎหมายโดรนในไทย ที่เจ้าของโดรนต้องรู้
                  </h2>

                  <p>
                    ใครที่มีโดรน ( Drone ) หรืออากาศยานไร้คนขับ
                    เครื่องที่สามารถบินไปในที่ต่างๆบังคับไม่ต่างจากเครื่องบินบังคับ
                    และสามารถถ่ายรูปถ่ายวีดีโอที่ติดบนโดรน
                    เพื่อถ่ายภาพมุมสวยๆได้ แต่ใช่ว่าซื้อเป็นเจ้าของโดรน ( Drone
                    ) แล้วจะสามารถใช้งานได้ทุกที่ทันที
                    เพราะในไทยก็มีกฎหมายโดรนด้วย เช่นเดียวกับอีกหลายประเทศ
                    ดังนั้นมาดูกันกับกฎหมายโดรนในไทย ที่เจ้าของโดรนต้องรู้
                  </p>
                  <p>
                    สำนักงานการบินพลเรือนแห่งประเทศไทย CAAT ได้โพสต์ภาพ
                    Infographic เกี่ยวกับ กฎหมายน่ารู้เกี่ยวกับโดรน Unmanned
                    Aerial Vehicle (UAV) และ กฎการขึ้นทะเบียนโดรน Unmanned
                    Aerial Vehicle (UAV) เพื่ออธิบายและเข้าใจง่ายขึ้น
                    โดยรายละเอียดข้อกฎหมายการใช้โดรนในไทยมีดังนี้
                  </p>
                  <p>
                    ประกาศกระทรวงคมนาคม เรื่อง
                    หลักเกณฑ์การอนุญาตและเงื่อนไขในการบังคับหรือปล่อยอากาศยานซึ่งไม่มีนักบินประเภทอากาศยานที่ควบคุมการบินจากภายนอก
                    พ.ศ. 2558 ซึ่งลงประกาศตั้งแต่วันที่ 2 กรกฎาคม พ.ศ. 2558
                  </p>
                </Carousel.Item>

                <Carousel.Item className="center-text ">
                  <div className="center-img" />
                  <h2 style={{ border: "bold" }}>
                    สำหรับการขึ้นทะเบียนอากาศยานไร้คนขับ (UAV) หรือ โดรนนั้น
                  </h2>
                  <p>- โดรนติดกล้องต้องขึ้นทะเบียนทุกกรณี</p>
                  <p>- โดรนที่หนักเกิน 2 กิโลกรัม ต้องขึ้นทะเบียนทุกกรณี</p>
                  <p>
                    - โดรนที่น้ำหนักมากกว่า 25 กิโลกรัม
                    ต้องได้รับอนุญาตจากรัฐมนตรีว่าการกระทรวงคมนาคม
                  </p>
                  <p>- โดรนติดกล้องต้องขึ้นทะเบียนทุกกรณี</p>
                  <p>- โดรนที่หนักเกิน 2 กิโลกรัม ต้องขึ้นทะเบียนทุกกรณี</p>
                  <p>
                    - โดรนที่น้ำหนักมากกว่า 25 กิโลกรัม
                    ต้องได้รับอนุญาตจากรัฐมนตรีว่าการกระทรวงคมนาคม
                  </p>
                </Carousel.Item>

                <Carousel.Item className="center-text">
                  <div className="center-img" />
                  <h2 style={{ border: "bold" }}>
                    อากาศยานในประกาศนี้แบ่งเป็นสองประเภทตามวัตถุประสงค์คือ
                  </h2>

                  <p>
                    • ประเภท 1 ใช้เพื่อการเล่นเป็นงานอดิเรก เพื่อความบันเทิง
                    หรือเพื่อการกีฬา
                  </p>
                  <p>
                    • ประเภท 2 ใช้เพื่อวัตถุประสงค์อื่นนอกจากตามประเภท 1
                    คือรายงานข่าว รายการโทรทัศน์หรือภาพยนตร์
                    วิจัยและพัฒนาอากาศยาน หรือเพื่อการอื่น ๆ
                  </p>
                  <p>
                    • ประเภทที่ 2 นั้นกำหนดขนาดไม่เกิน 25 กิโลกรัม
                    ขณะที่ประเภทที่ 1 มีแบ่งย่อยตามขนาด ดังนี้
                  </p>
                  <p>
                    ประเภท 1.ข มีน้ำหนักเกิน 2 กิโลกรัมแต่ไม่เกิน 25 กิโลกรัม
                    กำหนดให้ผู้บังคับหรือปล่อยอากาศยานต้องมีอายุไม่ต่ำกว่า 20 ปี
                    ไม่เป็นผู้มีพฤติการณ์เป็นภัยต่อความมั่นคงของประเทศ
                    ไม่เคยโดนโทษจำคุกในความผิดตามกฎหมายยาเสพติดหรือศุลกากร
                    และต้องขึ้นทะเบียนต่ออธิบดีกรมการขนส่งทางอากาศ{" "}
                  </p>
                  <p style={{ color: "red" }}>
                    หากผู้ใดทำกระทำความผิดต่อกฎอย่างใดอย่างหนึ่งต้องระวางโทษจำคุกไม่เกิน
                    1 ปี หรือปรับไม่เกิน 40,000 บาท หรือทั้งจำทั้งปรับ
                  </p>
                </Carousel.Item>

                {/* <Carousel.Item className=" center-text">
                  <div className="center-img" />
                
                </Carousel.Item> */}
              </Carousel>

              <Offcanvas show={show} onHide={handleClose} placement="end">
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title>ระบบอากาศยานไร้คนขับ</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Card
                    style={{
                      marginTop: "0px",
                      width: "100%",
                    }}
                  >
                    <Card.Img src="https://lh6.googleusercontent.com/FDtfbVf1IXwhrc2Ye6FlACJXyWU2Fwn3FlefUsYs3rdeLZe6EbSXuLhYuHmgJquqgOHVkJ8qecvUcI3y1KulQ2UJUEZt9bozjV2IqkQODNA3X3Zi9rPIVlTamgqO4kEggvqwbtk" />
                    <Card.Body style={{ padding: "5%", marginBottom: "5%" }}>
                      <Card.Title style={{ color: "black" }}>
                        คุณสนใจที่จะเป็นนักบินโดรนหรือไม่?
                      </Card.Title>
                      <Card.Text>
                        ก่อนที่จะเป็นนักบินมาขึ้นทะเบียนนักบินก่อนสิ
                        จะได้บินโดรนแบบสบายใจและถูกกฎหมายด้วยนะ
                      </Card.Text>
                      <Button variant="primary" href="/regispilot" disabled>
                        คลิกเลย
                      </Button>
                    </Card.Body>

                    <Card.Img src="https://image.makewebeasy.net/makeweb/0/B0eVCyrKt/Agent/%E0%B8%A3%E0%B8%B9%E0%B8%9B%E0%B9%82%E0%B8%94%E0%B8%A3%E0%B8%99.jpg" />
                    <Card.Body style={{ padding: "5%" }}>
                      <Card.Title style={{ color: "black" }}>
                        รู้หรือไม่ต้องขึ้นทะเบียนโดรนก่อนนำโดรนขึ้นบินด้วยนะ
                      </Card.Title>
                      <Card.Text>
                        ก่อนที่จะนำโดรนขึ้นบินได้ต้องขึ้นทะเบียนให้ถูกต้องตามกฎหมายก่อน
                        ไม่งั้นโดรนตำรวจทางอากาศจับน้า
                      </Card.Text>
                      <Button variant="primary" href="/user/drone/regisdrone">
                        คลิกเลย
                      </Button>
                    </Card.Body>
                  </Card>
                </Offcanvas.Body>
              </Offcanvas>
            </div>
          </div>
          <div></div>
        </>
      )}
    </>
  );
};

export default Home;
